<div class="address-selector text-body-medium">

  <atm-closable-modal [isOpen]="showConfirmationModal" (modalClosedEmitter)="showConfirmationModal = false">
    <div class="confirmation-modal">
      <h4 class="text-title-4">¿Deseas cambiar la dirección de entrega?</h4>
      <span class="text-paragraph">
        Los pedidos solamente puede tener partidas relacionadas a una misma dirección, 
        por lo que tus cambios se perderán al seleccionar otra dirección.
      </span>
      <div class="actions">
        <button class="btn" type="button" (click)="showConfirmationModal = false">Cancelar</button>
        <button class="btn --primary" type="button" (click)="confirmSelection()">Cambiar Dirección</button>
      </div>
    </div>
  </atm-closable-modal>

  <div class="address-selector__selected" (click)="toggleShowAddresses()">
    <div class="selection">
      <span *ngIf="isAddressSelectionValid">
        {{(user$ | async)?.aliasCustumer}}
      </span>
      <span *ngIf="selectionLabel">{{ selectionLabel }}</span>
    </div>
    <div><ng-icon class="icon" name="heroChevronUp" size="20"></ng-icon></div>
  </div>

  <div class="address-selector__wrapper">
    <div class="address-selector__options" *ngIf="showAddresses">
      <button class="option btn" *ngFor="let address of addresses$ | async" (click)="selectAddress(address)">
        <div class="option-item">
          <span class="text-small-regular text-gray-green-900 customer">{{(user$ | async)?.aliasCustumer}}</span>
          <span class="text-body-medium text-gray-green-900 address">{{address.address}}</span>
        </div>
      </button>

      <button class="option other btn" (click)="selectAddress(null)" *ngIf="!otherAddressDisabled">
        <span>Solicitar entrega en otra dirección</span>
      </button>

    </div>
  </div>

</div>
